var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        "has-back-button": true,
        "has-mini-cart": true,
        "has-close-button": false,
        "is-open": _vm.isOpen,
        "modal-modifier": "fullscreen"
      },
      on: { closed: _vm.close }
    },
    [
      _vm.isOpen
        ? _c("TheProductDetails", {
            attrs: {
              "add-to-cart-url": _vm.addToCartUrl,
              context: _vm.context,
              loading: _vm.loading,
              product: _vm.product
            },
            on: {
              zoomopen: function($event) {
                _vm.isZoomOpen = true
              },
              zoomclose: function($event) {
                _vm.isZoomOpen = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }